import { L10n, loadCldr, registerLicense, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';

import ptBRComponents from '../assets/language/locale/pt-BR.json';
import ptBRCaGregorian from '../assets/language/pt-BR/ca-gregorian.json';
import ptBRCurrencies from '../assets/language/pt-BR/currencies.json';
import ptBRNumbers from '../assets/language/pt-BR/numbers.json';
import ptBRTimeZoneNames from '../assets/language/pt-BR/timeZoneNames.json';
import { environment } from '../environments/environment';

export function configureSyncfusion(): () => void {
  return () => {
    if (environment.syncfusionLicenseKey) {
      console.log('Registering Syncfusion license');
      registerLicense(environment.syncfusionLicenseKey);
    }

    loadCldr(ptBRNumbers, ptBRTimeZoneNames, ptBRCurrencies, ptBRCaGregorian);
    L10n.load(ptBRComponents);
    setCulture('pt-BR');
    setCurrencyCode('BRL');
  };
}